import * as React from 'react';

import {Flex} from 'rebass';
import * as Styled from './ImageGallery.style';

import birdseye from './Images/birdseye.jpg';
import ingredients from './Images/ingredients-blur.jpg';
import pan from './Images/pan.jpg';

const ImageGallery = () => (
  <Flex flexDirection={['column', 'row']} alignItems="center" justifyContent="center" m="32px auto">
    <Styled.Image src={birdseye} m={["8px 0", "0 8px"]} />
    <Styled.Image src={ingredients} m={["8px 0", "0 8px"]} />
    <Styled.Image src={pan} m={["8px 0", "0 8px"]} />
  </Flex>
);

export default ImageGallery;
